import React from 'react';
import './Header.scss';

const HomeIcon = () => {
  return (
    <a href="/home">
      <img className="logo" src="logo.png" alt="logo"></img>
    </a>
  );
};

export default HomeIcon;
